var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "header",
        { staticClass: "replboxHead", staticStyle: { position: "fixed" } },
        [
          _c(
            "div",
            {
              staticClass: "btn_back",
              on: {
                click: function($event) {
                  return _vm.$go(-1)
                }
              }
            },
            [_c("a", { staticClass: "button" })]
          )
        ]
      ),
      _c("div", { staticStyle: { "padding-top": "48px" } }, [
        _c(
          "table",
          {
            attrs: {
              id: "Table_01",
              width: "100%",
              border: "0",
              cellpadding: "0",
              cellspacing: "0",
              align: "center"
            }
          },
          [
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: { "background-color": "#8f66f3" },
                  attrs: { colspan: "2" }
                },
                [
                  _c("img", {
                    attrs: {
                      src:
                        _vm.$store.getters["systemStore/getImgPath"] +
                        _vm.promoDetail.dispBanner.img_path,
                      alt: "",
                      usemap: "#imagemap",
                      id: "promo_img"
                    }
                  }),
                  _vm.promoDetail.dispBanner.img_map_use_yn === "Y"
                    ? _c("map", {
                        attrs: { name: "imagemap" },
                        domProps: {
                          innerHTML: _vm._s(_vm.promoDetail.dispBanner.img_map)
                        },
                        on: { click: _vm.selectEvent }
                      })
                    : _vm._e()
                ]
              )
            ]),
            _c("div", { staticClass: "popup disp_01" }, [
              _c("div", { staticClass: "popup_container" }, [
                _c("header", { staticClass: "popup_header" }, [
                  _vm._v("안 내")
                ]),
                _c("div", { staticClass: "popup_content" }, [
                  _c("p", { domProps: { innerHTML: _vm._s(_vm.alertMsg) } })
                ]),
                _c("div", { staticClass: "popup_button" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn_large",
                      on: {
                        click: function($event) {
                          return _vm.$go(-1)
                        }
                      }
                    },
                    [_vm._v("확 인")]
                  )
                ])
              ]),
              _c("div", { staticClass: "dimBg" })
            ]),
            _vm._m(0)
          ]
        )
      ]),
      _c("Progress", { attrs: { active: _vm.progressActive } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup main_04" }, [
      _c("div", { staticClass: "popup_container" }, [
        _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
        _c("div", { staticClass: "popup_content" }, [
          _c("p", { staticStyle: { "text-align": "center" } }, [
            _vm._v("행사 URL이 복사되었습니다!"),
            _c("br"),
            _vm._v("지인에게 널리 공유해 주세요~")
          ])
        ]),
        _c("div", { staticClass: "popup_button" }, [
          _c("button", { staticClass: "btn_large" }, [_vm._v("확인")])
        ])
      ]),
      _c("div", { staticClass: "dimBg" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }